'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _detectPassiveEvents = require('detect-passive-events');

var _detectPassiveEvents2 = _interopRequireDefault(_detectPassiveEvents);

require('./scroll-to-top.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH ScrollToTop Component.
 * @param {Object} props The new component properties.
 * @returns {ReactElement} HTML markup for the component
 */
var ScrollToTop = function (_Component) {
    (0, _inherits3.default)(ScrollToTop, _Component);

    function ScrollToTop(props) {
        (0, _classCallCheck3.default)(this, ScrollToTop);

        var _this = (0, _possibleConstructorReturn3.default)(this, (ScrollToTop.__proto__ || (0, _getPrototypeOf2.default)(ScrollToTop)).call(this, props));

        _this.state = {
            isVisible: false
        };

        _this.data = {
            startValue: 0,
            currentTime: 0, // store current time of animation
            startTime: null,
            rafId: null
        };
        return _this;
    }

    (0, _createClass3.default)(ScrollToTop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.handleScroll(); // initialize state
            window.addEventListener('scroll', this.handleScroll.bind(this));
            window.addEventListener('wheel', this.stopScrolling.bind(this), _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
            window.addEventListener('touchstart', this.stopScrolling.bind(this), _detectPassiveEvents2.default.hasSupport ? { passive: true } : false);
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps, nextState) {
            return nextState.isVisible !== this.state.isVisible;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('scroll', this.handleScroll.bind(this));
            window.removeEventListener('wheel', this.stopScrolling.bind(this), false);
            window.removeEventListener('touchstart', this.stopScrolling.bind(this), false);
        }
    }, {
        key: 'handleScroll',
        value: function handleScroll() {
            if (window.pageYOffset > this.props.showUnder) {
                this.setState({ isVisible: true });
            } else {
                this.setState({ isVisible: false });
            }
        }
    }, {
        key: 'scrollStep',
        value: function scrollStep(timestamp) {
            var _this2 = this;

            if (!this.data.startTime) {
                this.data.startTime = timestamp;
            }

            this.data.currentTime = timestamp - this.data.startTime;

            var easeOutCubic = function easeOutCubic() {
                var _data = _this2.data,
                    currentTime = _data.currentTime,
                    startValue = _data.startValue;
                var _props = _this2.props,
                    topPosition = _props.topPosition,
                    duration = _props.duration;

                var x = topPosition - startValue;
                _this2.data.currentTime = currentTime / duration - 1;

                return x * (Math.pow(_this2.data.currentTime, 3) + 1) + startValue;
            };

            var position = easeOutCubic();

            if (window.pageYOffset <= this.props.topPosition) {
                this.stopScrolling();
            } else {
                window.scrollTo(window.pageYOffset, position);
                this.data.rafId = window.requestAnimationFrame(this.scrollStep.bind(this));
            }
        }
    }, {
        key: 'stopScrolling',
        value: function stopScrolling() {
            window.cancelAnimationFrame(this.data.rafId);
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            this.stopScrolling();
            this.data.startValue = window.pageYOffset;
            this.data.currentTime = 0;
            this.data.startTime = null;
            this.data.rafId = window.requestAnimationFrame(this.scrollStep.bind(this));
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var style = {
                opacity: this.state.isVisible ? 1 : 0,
                visibility: this.state.isVisible ? 'visible' : 'hidden',
                transitionProperty: 'opacity, visibility'
            };

            return (0, _jsx3.default)('div', {
                className: 'sb-scroll-to-top',
                style: style,
                onClick: function onClick() {
                    return _this3.handleClick();
                }
            }, void 0, this.props.children);
        }
    }]);
    return ScrollToTop;
}(_react.Component);

exports.default = ScrollToTop;
//# sourceMappingURL=ScrollToTop.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/scrollToTop/ScrollToTop.js
// module id = 598
// module chunks = 0